import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key';
const projectRef = (() => {
  try {
    return new URL(url).hostname.split('.')[0];
  } catch (_) {
    return '';
  }
})();
const authStorageKey = projectRef ? `sb-${projectRef}-auth-token` : '';

export const clearStoredSupabaseSession = () => {
  if (typeof window === 'undefined') return;
  try {
    if (authStorageKey) window.localStorage.removeItem(authStorageKey);
    Object.keys(window.localStorage)
      .filter((key) => /^sb-[^-]+-auth-token$/.test(key))
      .forEach((key) => window.localStorage.removeItem(key));
  } catch (_) {
    // localStorage can be unavailable in private/restricted contexts.
  }
};

if (typeof window !== 'undefined' && !window.__cardpassSupabaseAuthRecovery) {
  window.__cardpassSupabaseAuthRecovery = true;
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = String(reason?.message || reason || '');
    if (/Invalid Refresh Token|Refresh Token Not Found/i.test(message)) {
      clearStoredSupabaseSession();
      event.preventDefault();
    }
  });
}

export const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true }
});
